import React from 'react'
import DefaultLayout from '../components/layout/DefaultLayout'
import Hero from '../components/sections/Hero'
import OverviewSection from '../components/sections/OverviewSection'
import ContributeSection from '../components/sections/ContributeSection'
import FaqSection from '../components/sections/FaqSection'
import ResultSection from '../components/sections/ResultSection'

export default function Result() {
  return (
    <DefaultLayout>
       
         <Hero />
         <OverviewSection />
         <ResultSection />
         <ContributeSection />
         <FaqSection />
       

    </DefaultLayout>
  )
}
